import { Component, h } from 'preact'
import Header from '../header'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import InputGroup from '../ui-components/InputGroup'

interface Props {
  config: { [key: string]: number}
}

interface State {
  seatLimit?: number,
  messageType?: string | null,
  message?: string
}

class CommunityConfiguration extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      ...props.config,
      messageType: null,
      message: ''
    }
    this.onSave = this.onSave.bind(this)
  }

  async onSave () {
    this.setState({ messageType: null })
    const response = Axios.post('/settings/configuration/save', {
      config: { seatLimit: this.state.seatLimit || 0 }
    })

    try {
      await Promise.all([response])
      this.setState({ messageType: 'success', message: 'Community configuration successfully saved!' })
    } catch (err) {
      this.setState({ messageType: 'error', message: 'Something went wrong!' })
    }
  }

  render ({ config }: Props, { messageType, message, seatLimit }: State) {
    return (
      <div className='community-configuration-page'>
        <Header
          title='Community Configuration'
          hasBreadcrumb={false}
          saveCallback={this.onSave}
        />
        {messageType ? <AlertComponent messageType={messageType} message={message} sticky isVisibleFor={5000} /> : null}
        <div className='community-configuration'>
          <InputGroup
            title='Seat limit'
            type='number'
            onChange={(e: { target: HTMLInputElement }) => {
              this.setState({ seatLimit: parseInt(e.target.value) })
            }}
            meta='Enter the seat limit for this instance below. To set an unlimited number of seats, enter 0.'
            value={seatLimit} />
        </div>
      </div>
    )
  }
}

export default CommunityConfiguration
